/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Stop_Call_EarlyInputs */

const fr_stop_call_early = /** @type {(inputs: Stop_Call_EarlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avance de ${i?.count} minute${i?.plural}`)
};

const en_stop_call_early = /** @type {(inputs: Stop_Call_EarlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minute${i?.plural} early`)
};

/**
* | output |
* | --- |
* | "{count} minute{plural} early" |
*
* @param {Stop_Call_EarlyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const stop_call_early = /** @type {((inputs: Stop_Call_EarlyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stop_Call_EarlyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_stop_call_early(inputs)
	return en_stop_call_early(inputs)
});